if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') return;

        const swiperEl = this.querySelector('.cart-recommendations__swiper');
        if (!swiperEl) return;

        const desktopSlides = parseFloat(this.dataset.desktopSlides) || 1;
        const mobileSlides = parseFloat(this.dataset.mobileSlides) || 1;
        const cardGap = parseInt(this.dataset.cardGap, 10) || 12;
        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
        const maxSlidesPerView = Math.max(desktopSlides, mobileSlides);
        // Loop clones slides; with too few real slides that looks like duplicates.
        const shouldLoop = slideCount > maxSlidesPerView;

        this.swiper?.destroy(true, true);

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: mobileSlides,
          spaceBetween: cardGap,
          loop: shouldLoop,
          navigation: {
            prevEl: this.querySelector('.cart-recommendations__nav-btn--prev'),
            nextEl: this.querySelector('.cart-recommendations__nav-btn--next'),
          },
          breakpoints: {
            750: {
              slidesPerView: desktopSlides,
              spaceBetween: cardGap,
            },
          },
        });
      }
    }
  );
}
